import {
    MissionCrewDetailsDto,
    MissionNoticeAcknowledgementDto,
    PersonDto
} from '@flyfreely-portal-ui/flyfreely';
import { formatPerson } from 'libs/ui/src/lib/pipes/domain/formatPerson.pipe';

/** A mission notice acknowledgement with the acknowledger's name resolved. */
export interface MissionNoticeAcknowledger {
    personId: number;
    /** Undefined when the acknowledger is not on the mission crew. */
    name?: string;
    acknowledgementTime: string;
}

/**
 * Resolves the names of the people that have acknowledged a mission notice
 * from the mission crew, falling back to the current user.
 */
export function resolveMissionNoticeAcknowledgers(
    acknowledgementList: MissionNoticeAcknowledgementDto[] | undefined,
    missionCrewDetails: MissionCrewDetailsDto[] | undefined,
    currentUser: PersonDto | undefined
): MissionNoticeAcknowledger[] {
    return (acknowledgementList ?? []).map(acknowledgement => {
        const crewMember = (missionCrewDetails ?? []).find(
            c => c.person?.id === acknowledgement.personId
        );
        const person =
            crewMember?.person ??
            (acknowledgement.personId === currentUser?.id
                ? currentUser
                : undefined);
        return {
            personId: acknowledgement.personId,
            name: person != null ? formatPerson(person) : undefined,
            acknowledgementTime: acknowledgement.acknowledgementTime
        };
    });
}
